import {
    FC,
    ReactElement,
    useEffect,
    useMemo,
} from 'react'

import { MultiUsersSelect } from '../../../compositions'
import { BasicUser } from '../../../entities/User/User'
import { useTypedDispatch, useTypedSelector } from '../../../redux/store'
import { getBasicUsers } from '../../../redux/users/usersActions'

interface ConnectedMultiUsersSelectProps {
    closeMenuOnSelect?: boolean;
    controlShouldRenderValue?: boolean;
    isDisabled?: boolean;
    departmentId?: string;
    excludeUsers?: string[];
    onSelect: (user: BasicUser[]) => void;
    className?: string;
}

const ConnectedMultiUsersSelect: FC<ConnectedMultiUsersSelectProps> = ({
    closeMenuOnSelect = false,
    controlShouldRenderValue = true,
    isDisabled = false,
    departmentId,
    excludeUsers = [],
    onSelect,
    className = '',
}): ReactElement => {
    const dispatch = useTypedDispatch()

    const { isLoading, basicUsers } = useTypedSelector(state => state.pacoUsersReducer)

    const users = useMemo(() => (
        basicUsers.filter(user => ! excludeUsers.includes(user.id))
    ), [basicUsers, excludeUsers])

    useEffect(() => {
        dispatch(getBasicUsers({
            ...(departmentId && { departments: [departmentId] }),
        }))
    }, [])

    return (
        <MultiUsersSelect
            closeMenuOnSelect={closeMenuOnSelect}
            controlShouldRenderValue={controlShouldRenderValue}
            isDisabled={isDisabled || isLoading}
            users={users}
            onSelect={onSelect}
            className={className}
        />
    )
}

export default ConnectedMultiUsersSelect
